import { makeHeadingPropsSelector } from "@client/content/selectors";
import { type RootContainerProps } from "@client/content/types";
import { getNoImageUrl } from "@client/lib/assets";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector, getSettingValueSelector } from "@client/selectors";
import { type AppState, type EntityRef } from "@client/types";
import { localStateSelector } from "../selectors";
import Component, { type BlogListItemProps } from "./component";
import { makeDescriptionStyleSelector, makeStyleSelector } from "./selectors";

export type BlogListItemContainerProps = RootContainerProps & {
  parentId: string;
};

const makeMapStateToProps = () => {
  const descriptionStyleParentSelector = makeDescriptionStyleSelector();
  const excerptLimitParentSelector = getSettingValueSelector(TargetSelector.Entity, "limit", "excerpt");
  const styleParentSelector = makeStyleSelector();
  const titleHeadingPropsParentSelector = makeHeadingPropsSelector(TargetSelector.Entity, "title");

  return (state: AppState, { id, ...props }: BlogListItemContainerProps): BlogListItemProps => {
    const selectorArgs: EntityRef = { id: props.parentId, source: props.source };

    const localState = localStateSelector(state, selectorArgs);
    return {
      ...props,
      descriptionStyle: descriptionStyleParentSelector(state, selectorArgs),
      id,
      excerptLimit: excerptLimitParentSelector(state, selectorArgs),
      noImageUrl: getNoImageUrl(),
      post: localState.items.find((p) => p.id === id)!,
      style: styleParentSelector(state, selectorArgs),
      titleHeading: titleHeadingPropsParentSelector(state, selectorArgs)
    };
  };
};

export default connectCustom(makeMapStateToProps)(Component);
